import React from 'react';

interface CaptureRateBadgeProps {
  rate: number;
}

const CaptureRateBadge: React.FC<CaptureRateBadgeProps> = ({ rate }) => (
  <span
    className="inline-flex items-center rounded-full bg-sky-50 px-2 py-0.5 text-xs font-medium text-sky-700 ring-1 ring-inset ring-sky-600/20"
    data-testid="capture-rate-badge"
  >
    {Math.round(rate * 100)}% Capture
  </span>
);

export default CaptureRateBadge;
